import React, {useState, useContext, useEffect} from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import {currentResource, labels} from '../../../../../../util/utils';
import {findBodyRelatedObject} from '../../../../../../reducers/FormData/formdatareducer';
import {WIDTH_30, clientSideEventNames} from '../../../../../../util/uiconstants';
import EditADCContainer from '../../../../../Main/ADC/EditADCContainer';
import {DocumentEngagementIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import {RelatedCanvasForm} from '../../../Section/RelatedCanvasForm';
import CompareSnapshotLabel from '../../../../CanvasForm/CompareSnapshotLabel';
import {useSelector} from 'react-redux';
import Utility from '../../../../../../util/utilityfunctions';
import {useDocumentId, useEngagementId, useUserPreferences} from '../../../../../../util/customHooks';
import Icon from '../../../../BaseComponentWrappers/MotifIcon';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';

export default function RiskRelatedObject(props) {
	const {data, isTopLevel, bodyId, isSnapshotView} = props,
		currentLevel = isTopLevel ? 1 : data.level;

	const [showModal, setShowModal] = useState(false),
		[myData, setMyData] = useState(data),
		[isObjectAssociatedToOtherForm, setIsObjectAssociatedToOtherForm] = useState(false);

	const engagementId = useEngagementId(),
		documentEngagementId = useContext(DocumentEngagementIdContext),
		documentId = useDocumentId();

	const formBodyData = useSelector((store) => store.formBodyData),
		userPreferences = useUserPreferences();

	let riskTypeDescription;

	if (data.riskTypeId) {
		riskTypeDescription = currentResource.riskTypes[data.riskTypeId - 1]?.abbrev;
	}

	let riskBadge = (
		<section className="RiskRelatedIcon">
			<Icon className="small" size="16" src={IconoirCustomRiskBolt} title={labels.boltIconTitle} />
			<span className="RiskRelatedIconText">{riskTypeDescription}</span>
		</section>
	);

	const loadEdit = () => {
		if (!isSnapshotView) {
			setShowModal(!showModal);
		}
	};

	const showHideModel = (showModal) => {
		setShowModal(showModal);
	};

	const showHideIcon = () => {
		if (
			(myData && myData.secondaryRelatedCanvasForm && myData.secondaryRelatedCanvasForm.length > 0) ||
			(myData && myData.primaryRelatedCanvasForm && myData.primaryRelatedCanvasForm.length > 0)
		) {
			setIsObjectAssociatedToOtherForm(true);
		}
	};

	useEffect(() => {
		if (bodyId) {
			if (formBodyData && formBodyData.length > 0) {
				let bodies = formBodyData[0].bodies;
				let toUpdate = undefined;
				for (let i = 0; i < bodies.length; i++) {
					let edited = findBodyRelatedObject(bodies[i].bodyRelatedObjects, myData.entityId, myData.entityUId);
					if (edited) {
						toUpdate = edited;
						break;
					}
				}
				if (toUpdate) {
					let newData = {...myData};
					newData.entityName = data.entityName;
					setMyData(newData);
					showHideIcon();
				}
			}
		}
	}, [formBodyData]);

	const onCollapseChange = (e) => {
		if (e.detail.isExpanded) {
			let width = (window.innerWidth * WIDTH_30) / 100;
			setNameWidthDockView(width);
		} else {
			let width = (window.innerWidth * WIDTH_50) / 100;
			setNameWidthDockView(width);
		}
	};

	useEffect(() => {
		showHideIcon();

		window.addEventListener(clientSideEventNames.onCollapseChange, onCollapseChange);
		return () => {
			window.removeEventListener(clientSideEventNames.onCollapseChange, onCollapseChange);
		};
	}, []);

	return (
		<StyledRiskRelatedObject className={`RiskRelatedObject entity-content entity-content-level-${currentLevel}`}>
			<section className={`entity-content-main ${Utility.getClasstoDisableADCLink(userPreferences, isSnapshotView)}`}>
				{riskTypeDescription && riskBadge}
				<section className="entityContent">
					<EllipsesControl
						content={data.entityName}
						tooltip={data.entityName}
						noOfLines={2}
						tooltipClass="tooltipCustomWidth"
						onClick={loadEdit}
					/>
				</section>
				{showModal && (
					<EditADCContainer
						showHideModel={showHideModel}
						documentId={documentId}
						documentEngagementId={documentEngagementId}
						engagementId={engagementId}
						bodyId={bodyId}
						item={data}
					/>
				)}
			</section>
			{!isSnapshotView && isObjectAssociatedToOtherForm ? (
				<>
					<section className="entity-content-data FourthCol WcgwRelated">
						<RelatedCanvasForm relatedCanvasFormDetails={myData} documentEngagementId={documentEngagementId} />
					</section>
				</>
			) : (
				<>{isSnapshotView && <CompareSnapshotLabel snapshotObject={data} />}</>
			)}
		</StyledRiskRelatedObject>
	);
}

const StyledRiskRelatedObject = styled.section`
	&.entity-content {
		&.entity-content-level-2 {
			margin-left: var(--px-20);
			border-bottom: var(--px-1) solid var(--neutrals-200);
			padding: var(--px-5) 0 var(--px-10) 0 !important;
			width: calc(100% - var(--px-210));
			&:last-child {
				border: 0;
			}
		}
		&.RiskRelatedObject {
			.entity-content-main {
				display: flex;
				width: calc(100% - var(--px-60));
				text-decoration: none !important;
				&:hover {
					.ellipses {
						text-decoration: underline !important;
					}
				}
				.ellipses {
					width: auto !important;
					max-width: 100% !important;
					margin-left: var(--px-20) !important;
				}
				.RiskRelatedIcon {
					display: inline-flex;
					align-items: center;
					cursor: default;
					width: var(--px-40);
					height: var(--px-24);
					margin: 0;
					.motif-icon {
						display: inline-flex;
					}
					svg {
						cursor: default;
						width: var(--px-16);
						height: var(--px-16);
						color: var(--neutrals-800);
						path {
							fill: currentColor;
						}
					}
					.RiskRelatedIconText {
						font-size: var(--px-12);
						margin-top: calc(var(--px-2) * -1);
						color: var(--neutrals-900);
						font-weight: bold;
						.motif-icon {
							display: inline-flex;
						}
					}
				}
				.entityContent {
					display: inline-flex;
					margin-top: var(--px-3);
					width: calc(100% - var(--px-40));
				}
				&.disableLinksExternalUsers {
					pointer-events: none;
				}
			}
			&.entity-content-level-2 {
				.entity-content-main {
					.entityContent {
						width: calc(100% - var(--px-40));
						.ellipses-multilines {
							cursor: pointer !important;
							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}
		}
	}
`;
